import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { IconBrandGoogle } from '@tabler/icons-react';
import { Button } from '@/components/ui/button';
import MainCard from '../components/MainCard';
export function LoginPage() {
  const { login } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const error = searchParams.get('error');
    if (error) {
      toast.error(`Login failed: ${error}`);
    }
    
    const success = searchParams.get('login');
    if (success === 'success') {
      toast.success('Login successful!');
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/50 dark:bg-background py-12 px-4">
      <div className="w-full max-w-sm">
        <MainCard className="shadow-lg">
          <div className="flex flex-col items-center gap-6">
            <div className="flex flex-col items-center gap-1">
              <h1 className="text-2xl font-semibold">
                Strata
              </h1>
              <p className="text-sm text-muted-foreground">
                Sign in to access the support tools
              </p>
            </div>

            <Button
              onClick={login}
              size="lg"
              className="w-full mt-2"
            >
              <IconBrandGoogle className="size-5" />
              Sign in with Google
            </Button>

            <p className="text-xs text-muted-foreground text-center mt-2">
              By signing in, you agree to our terms of service and privacy policy.
            </p>
          </div>
        </MainCard>
      </div>
    </div>
  );
}
